import { render, staticRenderFns } from "./subscription-details.vue?vue&type=template&id=55b7ba7f&"
import script from "./subscription-details.vue?vue&type=script&lang=js&"
export * from "./subscription-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports